import { useMemo } from 'react';
import { useGoalsOptionsQuery } from '../api/useGoalsOptionsQuery';
import { useGoalQuery } from '../api/useGoalQuery';
import { combineQueryResults } from '../../CommonUtils/combineQueryResults';

interface Params {
  clientId: string;
  categoryId: string;
  goalId: string;
}

export const useSetGoal = ({ clientId, categoryId, goalId }: Params) => {
  const goalOptionsQueryResult = useGoalsOptionsQuery({
    clientId,
    categoryId,
  });

  const goalQueryResult = useGoalQuery({
    clientId,
    goalId,
  });

  const data = useMemo(() => {
    if ((goalId && !goalQueryResult.data) || !goalOptionsQueryResult.data) {
      return null;
    }

    return {
      goal: goalId ? goalQueryResult.data : null,
      options: goalOptionsQueryResult.data,
    };
  }, [goalId, goalOptionsQueryResult.data, goalQueryResult.data]);

  return {
    ...(goalId
      ? combineQueryResults([goalQueryResult, goalOptionsQueryResult])
      : goalOptionsQueryResult),
    data,
  };
};
